// Canonical Czech labels for SystemRole values.
//
// IMPORTANT — see AGENTS.md § Terminologický slovník. Do NOT translate
// these terms freely; always import from here so the whole UI is
// consistent.
//
//   judge       → Porotce      (NEVER "Rozhodčí")
//   athlete     → Soutěžící    (NEVER "Závodník" / "Sportovec")
//   team_leader → Vedoucí      (NEVER "Vedoucí týmu" / "Šéf týmu")
//   coach       → Trenér
//   assistant   → Asistent
//   admin       → Administrátor
//   members_admin     → Správce členské základny
//   members_viewer    → Čtení členské základny
//   competitions_admin → Správce soutěží
//   competitions_viewer → Čtení soutěží
//   global_viewer     → Čtení všeho
//   federation_admin  → Správce federace
//   custom_pages_manager → Správce stránek
//   notices_manager      → Správce oznámení

import type { Assignment, SystemRole } from "../../auth/queries";

export const ROLE_LABEL: Record<SystemRole, string> = {
  admin: "Administrátor",
  members_admin: "Správce členské základny",
  members_viewer: "Čtení členské základny",
  competitions_admin: "Správce soutěží",
  competitions_viewer: "Čtení soutěží",
  global_viewer: "Čtení všeho",
  judge: "Porotce",
  federation_admin: "Správce federace",
  competition_organizer: "Organizátor soutěže",
  custom_pages_manager: "Správce stránek",
  notices_manager: "Správce oznámení",
  team_leader: "Vedoucí",
  coach: "Trenér",
  assistant: "Asistent",
  athlete: "Soutěžící",
};

export const SCOPE_LABEL: Record<Assignment["scope_type"], string> = {
  global: "globálně",
  federation: "federace",
  team: "tým",
  competition: "soutěž",
};
